import { Vector3 } from "three";
import * as Config from "../config/ViewerConfig";
import { AutoAttenuablePointer } from "../object/AutoAttenuablePointer";
import { InputHandler } from "../utils/input-handler/input-handler";
import {
  IInputEventHandler,
  InputEventType,
  InputMultiPointerEvent,
  InputPointerType,
  IPinchArgs,
  ISwipeArgs,
} from "../utils/input-handler/interface";
import { Viewer } from "../viewer";

export type TPointPickerCallbackResponse = { point: Vector3 };
export interface IPointPickerCallback {
  onClick: (response: TPointPickerCallbackResponse) => void;
}

export class PointPicker implements IInputEventHandler {
  private _pointerMap: Map<string, AutoAttenuablePointer>;
  private _guidePointer: AutoAttenuablePointer;
  private _viewer: Viewer;
  private _inputHandler: InputHandler;
  private _callbacks: IPointPickerCallback;

  constructor(viewer: Viewer, inputHandler: InputHandler) {
    this._viewer = viewer;
    this._inputHandler = inputHandler;
    this._pointerMap = new Map();
    this._guidePointer = undefined;
  }

  startPicking(callbacks: IPointPickerCallback) {
    this._callbacks = callbacks;
    this._inputHandler.registerHandler(`pickingMode`, this);
    this._guidePointer = new AutoAttenuablePointer("temp", "", this._viewer);
    this._guidePointer.setVisibility(false);
    this._viewer
      .getScene(Config.SCENE_TYPE.POINTPICK)
      .add(this._guidePointer.getPickPointGroup());
    //setup the inputhandling for picking
  }

  endPicking() {
    //release the inputhandling for
    this._inputHandler.unregisterHandler(`pickingMode`);
    if (this._guidePointer) {
      this._guidePointer.dispose();
      this._guidePointer = undefined;
    }
  }

  public handlePointerEvent(
    pointer: { pointerType: InputPointerType; eventType: InputEventType },
    event: PointerEvent
  ) {
    let { clientX, clientY } = event;
    // if (event.pointerType === "touch") {
    //   //shift the point downward
    //   clientY += Config.TOUCH_OFFSET;
    // }

    if (
      pointer.eventType === InputEventType.CLICK &&
      pointer.pointerType === InputPointerType.PRIMARY
    ) {
      const point = this._viewer.intersectPointCloud({ clientX, clientY });
      if (point) {
        if (this._callbacks?.onClick) {
          this._callbacks.onClick({ point });
        }
        this._guidePointer.setPosition(point);
        this._guidePointer.setVisibility(true);
        this._viewer.updateRenderer();
      }
    }
    // if (
    //     pointer.eventType === InputEventType.POINTER_HOVER
    //   ) {
    //     const point = this._viewer.intersectPointCloud({ clientX, clientY });
    //     if (point) {
    //       this._tempPointer.setPosition(point);
    //       this._tempPointer.setVisibility(true);
    //       this._viewer.updateRenderer();
    //     }
    //   }
  }

  public addPickPoint(id: string, name: string, position: Vector3) {
    const pickPoint = new AutoAttenuablePointer(id, name, this._viewer);
    pickPoint.setPosition(position);
    this._pointerMap.set(id, pickPoint);
    this._viewer
      .getScene(Config.SCENE_TYPE.POINTPICK)
      .add(pickPoint.getPickPointGroup());
    this._guidePointer?.setVisibility(false);
    this._viewer.updateRenderer();
  }

  public updatePickPoint(id: string, name: string, position: Vector3): void {
    const point = this._pointerMap.get(id);
    if (point) {
      position && point.setPosition(position);
      name && point.setName(name);
      this._viewer.updateRenderer();
    }
    // this._flgRender = true;
  }

  public updatePickPointGuide(position: Vector3) {
    if (!this._guidePointer) {
      return;
    }
    if (!position) {
      this._guidePointer.setVisibility(false);
      return;
    }
    this._guidePointer.setPosition(position);
    this._guidePointer.setVisibility(true);
  }

  public deletePickPoint(id: string): void {
    const point = this._pointerMap.get(id);
    if (point) {
      point.dispose();
      this._viewer.updateRenderer();
      this._pointerMap.delete(id);
    }
  }

  public deleteAllPickPoint(): void {
    this._pointerMap.forEach((p) => p.dispose());
    this._pointerMap.clear();
  }

  public handleMultiplePointerEvent(
    eventType: InputMultiPointerEvent,
    args: ISwipeArgs | IPinchArgs
  ): void {}
}
